export const min = (value, min) => {
    if (value.length < min) {
        return `Минимальная длина - ${min} символов`;
    }
    return null;
};
